import './days_today.scss';

import moment from 'moment';
import { string } from 'prop-types';
import React from 'react';
import Moment from 'react-moment';
import { Badge } from 'reactstrap';

import { UI_DATE_FORMAT } from '../../utils/constants';
import { getPillColor } from './utils';

function DaysFromToday({ date }) {
  const target = moment(date);
  const today = moment().startOf('day');
  const distanceInDays = target.diff(today, 'days');
  const pillColor = getPillColor(distanceInDays);
  if (distanceInDays >= -1 && distanceInDays < 2) {
    const label = ['yesterday', 'today', 'tomorrow'][distanceInDays + 1];
    return (
      <time dateTime={target.format('x')} title={target.format(UI_DATE_FORMAT)}>
        <Badge color={pillColor} pill>
          {label}
        </Badge>
      </time>
    );
  }
  return date ? (
    <Badge color={pillColor} pill>
      <Moment from={today} withTitle titleFormat={UI_DATE_FORMAT}>
        {target}
      </Moment>
    </Badge>
  ) : null;
}
DaysFromToday.propTypes = {
  date: string,
};

DaysFromToday.defaultProps = {
  date: '',
};

export default DaysFromToday;
